import type { Company } from 'context/authentication/Company.types'
import type { CompaniesFilterValues } from 'context/CompaniesViewContext'
import { deleteRequest, getRequest, IDENTITY_PREFIX, postRequest, putRequest } from 'global/helpers/requests'
import { type PaginatedResults } from 'global/types/pagination'
import type { BulkCreateCompaniesDialogFormValues, CreateOrEditCompanyFormValues } from './CompanyManager.types'

export const COMPANIES_QUERY_KEY = 'companies'

export const getFilteredCompanies = async (
  page: number,
  filters: CompaniesFilterValues,
): Promise<PaginatedResults<Company>> => {
  const search = new URLSearchParams(
    Object.entries(filters).flatMap(([key, values]) => (values as string[]).map(value => [key, value])),
  )
  search.append('page', page.toString())
  return await getRequest<PaginatedResults<Company>>(`companies?${search.toString()}`, {}, IDENTITY_PREFIX)
}

export const createCompany = async (data: CreateOrEditCompanyFormValues): Promise<void> =>
  await postRequest<void>('companies', { body: data }, IDENTITY_PREFIX)

export const editCompany = async (cid: string, data: CreateOrEditCompanyFormValues): Promise<void> => {
  const processedData = {
    ...data,
    companyCid: cid,
  }
  return await putRequest<void>(`companies/${cid}`, { body: processedData }, IDENTITY_PREFIX)
}

export const deleteCompany = async (cid: string): Promise<void> => await deleteRequest<void>(`companies/${cid}`, {}, IDENTITY_PREFIX)

export const uploadBulkCompanies = async (data: BulkCreateCompaniesDialogFormValues): Promise<string[]> => {
  const formData = new FormData()
  formData.append('form', data.csv)
  return await postRequest<string[]>('companies/bulk', { body: formData }, IDENTITY_PREFIX)
}
